import { render, staticRenderFns } from "./CauselistList.vue?vue&type=template&id=15a0d4dc&scoped=true"
import script from "./CauselistList.vue?vue&type=script&lang=js"
export * from "./CauselistList.vue?vue&type=script&lang=js"
import style0 from "./CauselistList.vue?vue&type=style&index=0&id=15a0d4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0d4dc",
  null
  
)

export default component.exports